import { ChannelUnsubscribe, channelClient } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { dataFlushContract } from './dataFlushContract';

type FlushType = DomainMessagesTypes.dataFlushed | DomainMessagesTypes.projectDataFlushed;

function onFlush(type: FlushType, handler: () => void): ChannelUnsubscribe {
  return channelClient.onEventOfType(dataFlushContract, type, () => handler());
}

/** What the page hears when the worker drops stored data. */
export const dataFlushClient = {
  onDataFlushed(handler: () => void): ChannelUnsubscribe {
    return onFlush(DomainMessagesTypes.dataFlushed, handler);
  },

  onProjectDataFlushed(handler: () => void): ChannelUnsubscribe {
    return onFlush(DomainMessagesTypes.projectDataFlushed, handler);
  },
};
